// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__gw9mZ","title":"Header_title__3YdvJ","left":"Header_left__Ft2Ep","clinicName":"Header_clinicName__15YLW"};